/**
 * commonData全局方法
 * 
 */
import router from '../../router';
const commonData = {
    state: {
        userInfo:null,
    },
    
    getters: {},
    mutations: {
        userInfo(state, p){
            state.userInfo = p;
        }
       
    },
    actions: {
        userInfo({commit}, p){
            commit('userInfo', p)
        }
    }
}

export default commonData





// WEBPACK FOOTER //
// ./src/store/components/commonData.js